<section>
  <h2>Update NPN and FFM Id</h2>
  <p class="margin-top">Only authorized agents certified by the Health Insurance Marketplace are able to sell products from the Health Insurance Marketplace.
  Please enter your NPN# and requested information below.</p>

  <form [formGroup]="npnAndFFMChangeForm" (submit)="submit()">

    <!-- ffm1 -->
    <mat-form-field appearance="outline">
      <mat-label>FFM ID</mat-label>
      <input matInput formControlName="ffm1" [placeholder]="'FFM ID'"/>
      @if (npnAndFFMChangeForm.controls['ffm1'].errors?.required) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>

    <!-- ffm2 -->
    <mat-form-field appearance="outline">
      <mat-label>Verify FFM ID</mat-label>
      <input matInput formControlName="ffm2" [placeholder]="'FFM ID (confirm)'"/>
      @if (npnAndFFMChangeForm.controls['ffm2'].errors?.required) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>

    <!-- npn1 -->
    <mat-form-field appearance="outline">
      <mat-label>NPN</mat-label>
      <input matInput formControlName="npn1" [placeholder]="'NPN'"/>
      @if (npnAndFFMChangeForm.controls['npn1'].errors?.required) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>

    <!-- npn2 -->
    <mat-form-field appearance="outline">
      <mat-label>Verify NPN</mat-label>
      <input matInput formControlName="npn2" [placeholder]="'NPN (Confirm)'"/>
      @if (npnAndFFMChangeForm.controls['npn2'].errors?.required) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>

    <!-- attestation -->
    <mat-checkbox formControlName="attestation">
      <span class="text-wrap">I verify that this is my FFM ID and NPN number and certify that I am acting in compliance with all applicable state and federal laws, rules, regulations and guidance, including without limitation the terms of the Agent Broker General Agreement for the Federally-Facilitated Exchange Individual Market.</span>
    </mat-checkbox>

    <div class="button-container">
      <button mat-raised-button color="primary" type="submit">Submit</button>
    </div>

  </form>

</section>
